export var BADGE_DEFAULT = {
  backgroundColor: '#202020',
  badgeType: 'DISCOUNT',
  // default to discount
  badgeTypeDisplay: 'Discount',
  color: '#ffffff',
  compareAtPrice: 0,
  price: 0,
  text: '% off'
};
export var BADGE_TYPES = {
  CUSTOM: 'Custom',
  DISCOUNT: 'Discount',
  NONE: 'None'
};